import { render, staticRenderFns } from "./PagePastDueWizard.vue?vue&type=template&id=0b3778ea&scoped=true&"
import script from "./PagePastDueWizard.vue?vue&type=script&lang=js&"
export * from "./PagePastDueWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3778ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b3778ea')) {
      api.createRecord('0b3778ea', component.options)
    } else {
      api.reload('0b3778ea', component.options)
    }
    module.hot.accept("./PagePastDueWizard.vue?vue&type=template&id=0b3778ea&scoped=true&", function () {
      api.rerender('0b3778ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/pastduewizard/PagePastDueWizard.vue"
export default component.exports